// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b1e95004","442":"0fcefc20","558":"cc0ee293","645":"614ac977","664":"1e1fae0c","796":"367af00c","944":"2a88393f","975":"553531fe"}[chunkId] + ".chunk.js";
};